<template>
  <div class="company">
      <!--img :src="top" style="width: 100%;height: 450px">-->

    <div class="background">
      <div class="background-img"><img :src="img_1" style="width:450px;height:340px"></div>
      <div class="background-text">
        <p>新闻动态</p>
      </div>
    </div>

    <div class="con_data">
      <!-- 分类筛选区域 -->
      <div class="category-filter">
        <div class="filter-container">
          <div 
            class="filter-item" 
            :class="{ active: activeCate === 0 }"
            @click="filterByCategory(0)">
            全部
          </div>
          <div 
            v-for="(cate, index) in newsCategories" 
            :key="index"
            class="filter-item"
            :class="{ active: activeCate === cate.id }"
            @click="filterByCategory(cate.id)">
            {{ cate.name }}
          </div>
        </div>
      </div>
      
      <div class="main-content">
        <!-- 左侧新闻列表 -->
        <div class="news-main">
          <!-- 置顶新闻 -->
          <div class="featured-news" v-if="featuredNews">
            <router-link :to="{path:'/newDetails',query:{Id:featuredNews.Id}}">
              <div class="featured-image">
                <img :src="featuredNews.NewsImg" alt="置顶新闻">
                <div class="featured-tag">置顶</div>
              </div>
              <div class="featured-content">
                <h2>{{featuredNews.NewsTitle}}</h2>
                <p>{{featuredNews.NewsBrief || truncateContent(featuredNews.NewsContent)}}</p>
                <div class="featured-meta">
                  <span><i class="el-icon-date"></i> {{formatDate(featuredNews.CreateTime)}}</span>
                  <span><i class="el-icon-view"></i> {{featuredNews.ViewCount || 560}} 阅读</span>
                </div>
              </div>
            </router-link>
          </div>
          
          <!-- 新闻列表 -->
          <div class="news-container">
            <div class="news-item" v-for="(item, index) in displayedNews" :key="item.Id">
              <div class="news-image">
                <router-link :to="{path:'/newDetails',query:{Id:item.Id}}">
                  <img :src="item.NewsImg" alt="新闻图片">
                  <div class="image-overlay"></div>
                </router-link>
              </div>
              
              <div class="news-content">
                <div class="news-meta">
                  <span class="news-date">
                    <i class="el-icon-date"></i>
                    {{formatDate(item.CreateTime)}}
                  </span>
                  <span class="news-category" v-if="item.NewsCategory">
                    <i class="el-icon-collection-tag"></i>
                    {{item.NewsCategory}}
                  </span>
                </div>
                
                <h3 class="news-title">
                  <router-link :to="{path:'/newDetails',query: {Id:item.Id}}">
                    {{item.NewsTitle}}
                  </router-link>
                </h3>
                
                <p class="news-brief" v-if="item.NewsBrief">{{item.NewsBrief}}</p>
                <p class="news-brief" v-else>{{truncateContent(item.NewsContent)}}</p>
                
                <div class="news-action">
                  <router-link :to="{path:'/newDetails',query: {Id:item.Id}}" class="read-more">
                    阅读全文 <i class="el-icon-arrow-right"></i>
                  </router-link>
                </div>
              </div>
            </div>
            
            <!-- 无数据提示 -->
            <div class="no-data" v-if="displayedNews.length === 0">
              <i class="el-icon-warning-outline"></i>
              <p>暂无相关新闻</p>
            </div>
          </div>
          
          <!-- 分页区域 -->
          <div class="pagination-container" v-if="displayedNews.length > 0">
            <el-pagination
              background
              layout="prev, pager, next"
              :total="filteredNews.length"
              :current-page.sync="pageIndex"
              :page-size="pageSize"
              @current-change="handlePageChange">
            </el-pagination>
          </div>
        </div>
        
        <!-- 右侧边栏 -->
        <div class="news-sidebar">
          <!-- 热门文章 -->
          <div class="sidebar-section">
            <h3 class="sidebar-title">
              <i class="el-icon-hot-water"></i> 热门文章
            </h3>
            <div class="hot-news-list">
              <div class="hot-news-item" v-for="(item, index) in hotNews" :key="index">
                <router-link :to="{path:'/newDetails',query:{Id:item.Id}}">
                  <div class="hot-news-rank">{{index + 1}}</div>
                  <div class="hot-news-info">
                    <h4>{{item.NewsTitle}}</h4>
                    <div class="hot-news-meta">
                      <span><i class="el-icon-date"></i> {{formatDate(item.CreateTime)}}</span>
                      <span><i class="el-icon-view"></i> {{item.ViewCount || 0}}</span>
                    </div>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
          
          <!-- 新闻标签 -->
          <div class="sidebar-section">
            <h3 class="sidebar-title">
              <i class="el-icon-collection-tag"></i> 热门标签
            </h3>
            <div class="tag-cloud">
              <el-tag 
                v-for="(tag, index) in newsTags" 
                :key="index"
                size="small"
                effect="plain"
                @click="filterByTag(tag)">
                {{tag}}
              </el-tag>
            </div>
          </div>
          
          <!-- 联系我们 -->
          <div class="sidebar-section contact-section">
            <h3 class="sidebar-title">
              <i class="el-icon-service"></i> 联系我们
            </h3>
            <p>如果您有任何问题或建议，请随时联系我们</p>
            <el-button type="primary" icon="el-icon-message" size="small">
              立即咨询
            </el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from '../../components/pagination'
export default {
  name: "company",
  components:{
    Pagination,
  },
  data(){
    return {
      img_1:require('../../assets/07.png'),
      pageIndex: 1, //默认页码
      pageSize: 5, //显示条数
      pageTotal: 0, //总条数
      top:'',
      comData:[],
      activeCate: 0, // 当前选中的分类
      newsCategories: [
        { id: 1, name: '公司新闻' },
        { id: 2, name: '行业动态' },
        { id: 3, name: '技术分享' }
      ],
      newsTags: ['智能混凝土', '建筑科技', '数字化转型', '绿色建筑', '智能建造'],
      searchKeyword: ''
    }
  },
  computed: {
    // 获取置顶新闻
    featuredNews() {
      return this.comData.length > 0 ? this.comData[0] : null;
    },
    // 获取热门新闻
    hotNews() {
      // 这里模拟按阅读量排序，实际应从后端获取
      return [...this.comData]
        .sort((a, b) => (b.ViewCount || 0) - (a.ViewCount || 0))
        .slice(0, 5);
    },
    // 根据分类筛选新闻
    filteredNews() {
      if (this.activeCate === 0) {
        // 全部新闻，但排除置顶新闻
        return this.comData.filter((_, index) => index > 0);
      } else {
        // 按分类筛选
        return this.comData.filter(item => item.NewsCate === this.activeCate);
      }
    },
    // 当前页显示的新闻
    displayedNews() {
      const start = (this.pageIndex - 1) * this.pageSize;
      const end = start + this.pageSize;
      return this.filteredNews.slice(start, end);
    }
  },
  mounted() {
    this.getInfo();
    this.getTop();
  },
  methods:{
    //获取banner
    getTop() {
      let data = {params: {ImgCate: 9}}
      this.$axios.get('http://82.156.125.76:5000/api/Byt_Ent_Gateway/BytEntImgSelect', data).then(res => {
        res = typeof res.data == 'string' ? JSON.parse(res.data) : res.data;
        this.top = res.data[0].ImgPath;
      })
    },
    //获取信息
    getInfo(){
      let data = {params:{NewsCate:0}};
      this.$axios.get('http://82.156.125.76:5000/api/Byt_Ent_Gateway/BytEntNewsSelect',data).then(res=>{
        res = typeof res.data=='string'? JSON.parse(res.data):res.data;
        this.comData = res.data;
        this.pageTotal = res.data.length;
        console.log(res);
      })
    },
    // 处理分页变化
    handlePageChange(page) {
      this.pageIndex = page;
      // 页面滚动到顶部
      window.scrollTo({
        top: document.querySelector('.news-container').offsetTop - 100,
        behavior: 'smooth'
      });
    },
    // 按分类筛选
    filterByCategory(cateId) {
      this.activeCate = cateId;
      this.pageIndex = 1; // 重置页码
    },
    // 按标签筛选
    filterByTag(tag) {
      // 这里可以实现按标签筛选的逻辑
      this.$message.info(`按标签"${tag}"筛选的功能正在开发中`);
    },
    // 格式化日期
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
    },
    // 截取内容
    truncateContent(content) {
      if (!content) return '';
      // 移除HTML标签
      const plainText = content.replace(/<[^>]+>/g, '');
      return plainText.length > 100 ? plainText.substring(0, 100) + '...' : plainText;
    }
  }
}
</script>

<style scoped>
/* 页面整体样式 */
.company {
  background-color: #f9f9fa;
}

/* 顶部banner */
.top {
  position: relative;
}

.banner-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to bottom, rgba(0,0,0,0.3), rgba(0,0,0,0.7));
  display: flex;
  align-items: center;
  justify-content: center;
}

.banner-content {
  text-align: center;
  color: white;
  max-width: 800px;
  padding: 0 20px;
}

.banner-content h1 {
  font-size: 48px;
  font-weight: 600;
  margin-bottom: 15px;
  text-shadow: 0 2px 4px rgba(0,0,0,0.3);
  animation: fadeInDown 1s ease;
}

.banner-content p {
  font-size: 18px;
  opacity: 0.9;
  margin: 0;
  text-shadow: 0 1px 2px rgba(0,0,0,0.3);
  animation: fadeInUp 1s ease;
}

/* 分类筛选区域 */
.category-filter {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.05);
  margin-bottom: 30px;
  padding: 15px 20px;
  animation: fadeIn 0.8s ease;
}

.filter-container {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
}

.filter-item {
  padding: 8px 16px;
  border-radius: 20px;
  background: #f5f5f5;
  color: #666;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 14px;
}

.filter-item:hover {
  background: #e6f7ff;
  color: #1890ff;
}

.filter-item.active {
  background: #1890ff;
  color: white;
}

/* 主内容区域 */
.main-content {
  display: flex;
  gap: 30px;
}

.news-main {
  flex: 3;
  min-width: 0;
}

.news-sidebar {
  flex: 1;
  min-width: 280px;
}

/* 置顶新闻 */
.featured-news {
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 3px 15px rgba(0,0,0,0.08);
  margin-bottom: 30px;
  transition: all 0.3s ease;
}

.featured-news:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 30px rgba(0,0,0,0.1);
}

.featured-news a {
  display: flex;
  flex-direction: column;
  color: inherit;
  text-decoration: none;
}

.featured-image {
  position: relative;
  height: 300px;
  overflow: hidden;
}

.featured-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.6s ease;
}

.featured-news:hover .featured-image img {
  transform: scale(1.05);
}

.featured-tag {
  position: absolute;
  top: 15px;
  left: 15px;
  background: #ff4d4f;
  color: white;
  padding: 5px 10px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  box-shadow: 0 2px 6px rgba(255, 77, 79, 0.3);
}

.featured-content {
  padding: 25px;
}

.featured-content h2 {
  font-size: 22px;
  margin: 0 0 15px;
  color: #333;
  transition: color 0.3s ease;
}

.featured-news:hover .featured-content h2 {
  color: #1890ff;
}

.featured-content p {
  color: #666;
  line-height: 1.6;
  margin-bottom: 20px;
  font-size: 15px;
}

.featured-meta {
  display: flex;
  gap: 20px;
  color: #999;
  font-size: 13px;
}

.featured-meta span {
  display: flex;
  align-items: center;
}

.featured-meta i {
  margin-right: 5px;
}

/* 新闻容器 */
.news-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 30px;
}

/* 新闻项 */
.news-item {
  display: flex;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

.news-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.08);
}

/* 新闻图片 */
.news-image {
  width: 240px;
  height: 160px;
  overflow: hidden;
  position: relative;
  flex-shrink: 0;
}

.news-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
}

.news-item:hover .news-image img {
  transform: scale(1.05);
}

.image-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to bottom, rgba(0,0,0,0), rgba(0,0,0,0.2));
  opacity: 0;
  transition: opacity 0.3s ease;
}

.news-item:hover .image-overlay {
  opacity: 1;
}

/* 新闻内容 */
.news-content {
  flex: 1;
  padding: 20px 25px;
  display: flex;
  flex-direction: column;
}

.news-meta {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 10px;
  color: #999;
  font-size: 13px;
}

.news-date, .news-category {
  display: flex;
  align-items: center;
}

.news-meta i {
  margin-right: 5px;
}

.news-title {
  font-size: 18px;
  margin: 0 0 12px;
  line-height: 1.4;
}

.news-title a {
  color: #333;
  text-decoration: none;
  transition: color 0.3s ease;
}

.news-title a:hover {
  color: #1890ff;
}

.news-brief {
  color: #666;
  font-size: 14px;
  line-height: 1.6;
  margin-bottom: 15px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  flex: 1;
}

.news-action {
  margin-top: auto;
  text-align: right;
}

.read-more {
  display: inline-flex;
  align-items: center;
  color: #1890ff;
  font-size: 14px;
  text-decoration: none;
  transition: all 0.3s ease;
}

.read-more i {
  margin-left: 5px;
  transition: transform 0.3s ease;
}

.read-more:hover {
  color: #40a9ff;
}

.read-more:hover i {
  transform: translateX(3px);
}

/* 侧边栏样式 */
.sidebar-section {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.05);
  padding: 20px;
  margin-bottom: 20px;
}

.sidebar-title {
  font-size: 16px;
  color: #333;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #f0f0f0;
  display: flex;
  align-items: center;
}

.sidebar-title i {
  margin-right: 8px;
  color: #1890ff;
}

/* 热门文章列表 */
.hot-news-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.hot-news-item {
  display: flex;
  gap: 12px;
  padding-bottom: 15px;
  border-bottom: 1px dashed #f0f0f0;
}

.hot-news-item:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.hot-news-item a {
  display: flex;
  gap: 12px;
  color: inherit;
  text-decoration: none;
}

.hot-news-rank {
  width: 24px;
  height: 24px;
  background: #f5f5f5;
  color: #999;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 500;
  flex-shrink: 0;
  transition: all 0.3s ease;
}

.hot-news-item:nth-child(1) .hot-news-rank {
  background: #ff4d4f;
  color: white;
}

.hot-news-item:nth-child(2) .hot-news-rank {
  background: #faad14;
  color: white;
}

.hot-news-item:nth-child(3) .hot-news-rank {
  background: #52c41a;
  color: white;
}

.hot-news-info {
  flex: 1;
  min-width: 0;
}

.hot-news-info h4 {
  font-size: 14px;
  margin: 0 0 8px;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  line-height: 1.5;
  transition: color 0.3s ease;
}

.hot-news-item:hover .hot-news-info h4 {
  color: #1890ff;
}

.hot-news-meta {
  display: flex;
  justify-content: space-between;
  color: #999;
  font-size: 12px;
}

/* 标签云 */
.tag-cloud {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.tag-cloud .el-tag {
  cursor: pointer;
  transition: all 0.3s ease;
}

.tag-cloud .el-tag:hover {
  color: #1890ff;
  border-color: #1890ff;
}

/* 联系我们区域 */
.contact-section {
  text-align: center;
}

.contact-section p {
  margin-bottom: 15px;
  color: #666;
}

/* 无数据提示 */
.no-data {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 0;
  color: #999;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.05);
}

.no-data i {
  font-size: 48px;
  margin-bottom: 15px;
}

/* 分页容器 */
.pagination-container {
  display: flex;
  justify-content: center;
  margin-top: 30px;
}

/* 动画 */
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes fadeInDown {
  from { 
    opacity: 0;
    transform: translateY(-20px);
  }
  to { 
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInUp {
  from { 
    opacity: 0;
    transform: translateY(20px);
  }
  to { 
    opacity: 1;
    transform: translateY(0);
  }
}

/* 响应式调整 */
@media (max-width: 1200px) {
  .main-content {
    flex-direction: column;
  }
  
  .news-sidebar {
    order: -1;
  }
}

@media (max-width: 768px) {
  .banner-content h1 {
    font-size: 36px;
  }
  
  .news-item {
    flex-direction: column;
  }
  
  .news-image {
    width: 100%;
    height: 200px;
  }
  
  .featured-image {
    height: 200px;
  }
  
  .featured-content h2 {
    font-size: 18px;
  }
}
/*最上方背景*/
.background {
  background-color: #f5f5f5; /* 浅灰色背景 */
  width: 100%; /* 宽度100% */
  height: 300px; /* 最小高度 */
  padding: 20px; /* 内边距 */
  border-radius: 8px; /* 圆角 */
  box-shadow: 0 2px 10px rgba(0,0,0,0.1); /* 阴影效果 */
}
.background-img {
  position: relative;
  left: 60%;
  top: -15px;
}
.background-text{
  position: relative;
  font-size: 50px;
  font-weight: 700;
  font-family: "Microsoft YaHei";
  left: 27%;
  top: -300px;
}
</style>